import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioParalisacaoConsultaListaObrasParadas: [],
    removeStatusConsultaListaObrasParadas: [],
    setMostraAplicarFiltroConsultaListaObrasParadas: [],
    limpaFiltroConsultaListaObrasParadas: [],
    aplicarFiltroConsultaListaObrasParadas: ['filtro'],
})

const INITIAL_STATE = {
    exercicioParalisacao: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicioParalisacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioParalisacao: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_PARALISACAO_CONSULTA_LISTA_OBRAS_PARADAS]: removeExercicioParalisacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_LISTA_OBRAS_PARADAS]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_LISTA_OBRAS_PARADAS]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_LISTA_OBRAS_PARADAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_LISTA_OBRAS_PARADAS]: aplicarFiltro,
})
